<div class="shipment-form-actions" [attr.aria-busy]="loading() ? 'true' : null">
  @if (loading()) {
    <output class="visually-hidden" data-testid="ship-from-save-processing-status">
      {{ 'createShipment.actions.saveAndContinueLoading' | translate }}
    </output>
  }

  <puro-button
    type="button"
    variant="primary"
    size="large"
    data-testid="ship-from-save-and-continue"
    [loading]="loading()"
    [disabled]="disabled() || loading()"
    (buttonClick)="onSaveAndContinue()"
  >
    {{ 'createShipment.actions.saveAndContinue' | translate }}
  </puro-button>
</div>
